// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes animationRotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(1turn);
  }
}
/* Add Animation */
@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
._ad_container {
  height: calc(100vh - 70px);
  width: calc(100vw - 256px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 10000000;
}
@media (max-width: 576px) {
  ._ad_container {
    width: 100%;
    height: 100%;
    background: #171515;
  }
}

.ad_time {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  width: auto;
  position: absolute;
  bottom: 13%;
  right: 0;
  background: #222222 0% 0% no-repeat padding-box;
  padding: 10px 6px 8px 10px;
  z-index: 1;
}

.video_container {
  width: 100%;
  height: inherit;
  border-radius: 12px;
  background-color: #171515;
}

.img_container {
  width: 100%;
  height: inherit;
  border-radius: 12px;
  background-color: #262626;
}

.ancer {
  height: inherit;
  border-radius: 12px;
}

.transferent {
  position: absolute;
  width: 100%;
  height: 70px;
  bottom: 0px;
  background-color: transparent;
}

video::-webkit-media-controls-fullscreen-button {
  display: none;
}

video::-webkit-media-controls-play-button {
  display: none;
}

video::-webkit-media-controls-previous-time-display {
  display: none !important;
}

video::-webkit-media-controls-duration {
  display: none !important;
}

video::-webkit-media-controls-duration-display {
  display: none !important;
}

video::-webkit-media-controls-current-time-display {
  width: 100% !important;
}

video::-webkit-media-controls-mute-button {
  display: none !important;
}

video::-webkit-media-controls-volume-slider {
  display: none !important;
}

video::-webkit-media-controls-current-time-display {
  display: none !important;
}

video::-webkit-media-controls-time-remaining-display {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/_mixins.scss","webpack://./src/components/Advertisement/index.scss"],"names":[],"mappings":"AAGA;EACE;IACE,oBAAA;ECFF;EDIA;IACE,wBAAA;ECFF;AACF;ADKA,kBAAA;AAYA;EACE;IACE,WAAA;IACA,UAAA;ECJF;EDMA;IACE,MAAA;IACA,UAAA;ECJF;AACF;AA1BA;EACE,0BAAA;EACA,0BAAA;EACA,0CAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;AA4BF;ADDE;ECnCF;IAWI,WAAA;IACA,YAAA;IACA,mBAAA;EA6BF;AACF;;AA1BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,+CAAA;EACA,0BAAA;EACA,UAAA;AA6BF;;AA1BA;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;AA6BF;;AA1BA;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;AA6BF;;AA1BA;EACE,eAAA;EACA,mBAAA;AA6BF;;AA1BA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,6BAAA;AA6BF;;AA1BA;EACE,aAAA;AA6BF;;AA1BA;EACE,aAAA;AA6BF;;AA1BA;EACE,wBAAA;AA6BF;;AA1BA;EACE,wBAAA;AA6BF;;AA1BA;EACE,wBAAA;AA6BF;;AA1BA;EACE,sBAAA;AA6BF;;AA1BA;EACE,wBAAA;AA6BF;;AA1BA;EACE,wBAAA;AA6BF;;AA1BA;EACE,wBAAA;AA6BF;;AA1BA;EACE,wBAAA;AA6BF","sourcesContent":["@import \"./colors.scss\";\n@import \"./breakpoints\";\n\n@keyframes animationRotate {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n/* Add Animation */\n@-webkit-keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n@keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n// Small devices\n@mixin sm {\n  @media (max-width: #{$screen-sm-max}) {\n    @content;\n  }\n}\n\n@mixin upToSm {\n  @media (min-width: #{$screen-sm-min}) {\n    @content;\n  }\n}\n\n// Medium devices\n@mixin md {\n  @media (min-width: #{$screen-md-min}) {\n    @content;\n  }\n}\n\n// Large devices\n@mixin lg {\n  @media (min-width: #{$screen-lg-min}) {\n    @content;\n  }\n}\n\n// Extra large devices\n@mixin xl {\n  @media (min-width: #{$screen-xl-min}) {\n    @content;\n  }\n}\n\n// Custom devices\n@mixin rwd($screen) {\n  @media (min-width: #{$screen}px) {\n    @content;\n  }\n}\n\n@mixin screnRange($min, $max) {\n  @media (min-width: #{$min}px) and (max-width: #{$max}px) {\n    @content;\n  }\n}\n\n@mixin screenHeightRange($min, $max) {\n  @media (min-height: #{$min}px) and (max-height: #{$max}px) {\n    @content;\n  }\n}\n","@import \"../../styles/mixins\";\n\n._ad_container {\n  height: calc(100vh - 70px);\n  width: calc(100vw - 256px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  z-index: 10000000;\n\n  @include sm {\n    width: 100%;\n    height: 100%;\n    background: #171515;\n  }\n}\n\n.ad_time {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  width: auto;\n  position: absolute;\n  bottom: 13%;\n  right: 0;\n  background: #222222 0% 0% no-repeat padding-box;\n  padding: 10px 6px 8px 10px;\n  z-index: 1;\n}\n\n.video_container {\n  width: 100%;\n  height: inherit;\n  border-radius: 12px;\n  background-color: #171515;\n}\n\n.img_container {\n  width: 100%;\n  height: inherit;\n  border-radius: 12px;\n  background-color: #262626;\n}\n\n.ancer {\n  height: inherit;\n  border-radius: 12px;\n}\n\n.transferent {\n  position: absolute;\n  width: 100%;\n  height: 70px;\n  bottom: 0px;\n  background-color: transparent;\n}\n\nvideo::-webkit-media-controls-fullscreen-button {\n  display: none;\n}\n\nvideo::-webkit-media-controls-play-button {\n  display: none;\n}\n\nvideo::-webkit-media-controls-previous-time-display {\n  display: none !important;\n}\n\nvideo::-webkit-media-controls-duration {\n  display: none !important;\n}\n\nvideo::-webkit-media-controls-duration-display {\n  display: none !important;\n}\n\nvideo::-webkit-media-controls-current-time-display {\n  width: 100% !important;\n}\n\nvideo::-webkit-media-controls-mute-button {\n  display: none !important;\n}\n\nvideo::-webkit-media-controls-volume-slider {\n  display: none !important;\n}\n\nvideo::-webkit-media-controls-current-time-display {\n  display: none !important;\n}\n\nvideo::-webkit-media-controls-time-remaining-display {\n  display: none !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
